import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { resolveStaffAvatarSrc } from '../constants/defaultAvatar';

export type StaffAssigneeLike = {
  display_name: string;
  avatar_url?: string | null;
};

type Props = {
  assignee: StaffAssigneeLike | null | undefined;
  /** 一覧セルはやや小さめ */
  size?: number;
};

/** 担当者表示 */
const StaffAssigneeDisplay: React.FC<Props> = ({ assignee, size = 28 }) => {
  if (!assignee?.display_name) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }
  const src = resolveStaffAvatarSrc(assignee.avatar_url);
  const initial = assignee.display_name.trim().charAt(0) || '?';
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
      <Avatar src={src} sx={{ width: size, height: size, fontSize: Math.max(12, size * 0.38) }}>
        {initial}
      </Avatar>
      <Typography variant="body2" noWrap title={assignee.display_name} sx={{ fontSize: size <= 22 ? '0.8125rem' : undefined }}>
        {assignee.display_name}
      </Typography>
    </Box>
  );
};

export default StaffAssigneeDisplay;
